import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import {
  ImpactAssessmentListView,
  ImpactAssessmentListViewModel,
} from './../../../core/models/impact-assessment/impact-assessment-list-view';
import { ImpactService } from './../../../core/services/impact/impact.service';
import { ToastViewModel } from './../../../core/models/view-model/toast-view-model';
import { AdditionalFilter } from './../../../core/models/rulebook/additional-filter';
import { LinkedAssessmentModel } from 'src/app/core/models/impact-assessment/linked-assessment-model';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { ActivatedRoute } from '@angular/router';
import { debug } from 'console';

@Component({
  selector: 'app-linked-assessment',
  templateUrl: './linked-assessment.component.html',
  styleUrls: ['./linked-assessment.component.scss'],
})
export class LinkedAssessmentComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;
  @ViewChild('tableContent', { read: ElementRef })
  public tableContent: any;
  @ViewChild('autoKeyword') autoKeyword!: MatAutocomplete;
  @ViewChild('keywordInput') keywordInput!: ElementRef<HTMLInputElement>;

  filters: AdditionalFilter;
  impactAssessment: Array<ImpactAssessmentListView>;
  totalCount = 0;
  isTableLoaded = false;
  isLoading = false;
  myInnerHeight: any;
  endIndex = 0;
  visible = true;
  selectable = true;
  removable = true;
  templateNo:number;

  addOnBlur = true;
  keyCtrl = new FormControl();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredKeywords: string[];
  toastModel: ToastViewModel;
  isToastShow = false;

  constructor(
    private route: ActivatedRoute,
    private impactService: ImpactService,
    public dialogRef: MatDialogRef<LinkedAssessmentComponent>,
    
    @Inject(MAT_DIALOG_DATA) public linkedAssessment: LinkedAssessmentModel
  ) {
    this.myInnerHeight = window.innerHeight - 350;
    this.filters = new AdditionalFilter();
    this.impactAssessment = [];
    this.templateNo =  Number(this.route.snapshot.params['templateNo'])
    this.filteredKeywords = [];
    this.toastModel = new ToastViewModel();
  }

  ngOnInit(): void {
    
    this.filters.SortKey = 'updatedDB_Id';
    this.filters.IsDesc = true;
    this.fetchImpactAssessment();
  }

  handler(): void {
    this.endIndex = this.viewport.getRenderedRange().end;
  }

  fetchImpactAssessment(): void {
    
    this.isLoading = true;
    if(this.linkedAssessment.templateNumber == 6){
      this.impactService.getAllImpactAssessmentT6(this.filters).subscribe((result: ImpactAssessmentListViewModel) => {
        this.impactAssessment = result.data;
        this.totalCount = result.totalCount;
        this.isLoading = false;
        this.isTableLoaded = true;
        this.endIndex =
          this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
      });
    }
    else{
    this.impactService.getAllImpactAssessment(this.filters).subscribe((result: ImpactAssessmentListViewModel) => {
      this.impactAssessment = result.data;
      this.totalCount = result.totalCount;
      this.isLoading = false;
      this.isTableLoaded = true;
      this.endIndex =
        this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
    });
  }
  }

  sortImpactAssessment(key: string): void {
    this.filters.IsDesc = !this.filters.IsDesc;
    this.filters.SortKey = key;
    this.fetchImpactAssessment();
  }

  selectItem(event: any, id: number): void {  
    if (event.target.checked === true) {
      this.linkedAssessment.linkedAssessment.push(id);
    } else {
      const index = (
        this.linkedAssessment.linkedAssessment as number[]
      ).indexOf(id);
      if (index >= 0) {
        (this.linkedAssessment.linkedAssessment as number[]).splice(index, 1);
      }
    }
  }

  // Keywords events
  add(event: MatChipInputEvent): void {
    if (!this.autoKeyword.isOpen) {
      const input = event.input;
      const value = event.value;

      if ((value || '').trim()) {
        this.filters.searchQuery.push(value.trim());
      }

      if (input) {
        input.value = '';
      }

      this.keyCtrl.setValue(null);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.filters.searchQuery) {
      this.filters.searchQuery.push(event.option.viewValue);
    } else {
      this.filters.searchQuery = [];
      this.filters.searchQuery.push(event.option.viewValue);
    }
    this.keywordInput.nativeElement.value = '';
    this.keyCtrl.setValue(null);
    this.keyCtrl.disable();
    this.keyCtrl.enable();
  }

  remove(searchstr: string): void {
    const index = (this.filters.searchQuery as string[]).indexOf(searchstr);

    if (index >= 0) {
      (this.filters.searchQuery as string[]).splice(index, 1);
    }
  }

  initFilter(): void {
    this.filters.searchQuery = [];
  }

  closeDialog(): void {
    this.dialogRef.close(this.linkedAssessment);
  }

  checkedIfExist(id: number): string {
    const index = (this.linkedAssessment.linkedAssessment as number[]).indexOf(id);
    return index >= 0 ? 'checked' : '';
  }
}
